import { startApp } from './Client/App';

startApp();
